import type {
  DataRefId,
  MiddlewareStates,
  NetworkRequestor,
  OverreactSpec,
  RequestHeaders,
  RequestVerb,
} from '../public-types';
import type { Store } from '../store';

export interface WrappedRequestorOptions<
  TVariables extends object,
  TResponse,
> {
  requestor: NetworkRequestor<TResponse>;
  uri: string;
  verb: RequestVerb;
  headers?: RequestHeaders;
  payload?: unknown;
  spec: OverreactSpec<TVariables>;
  variables: TVariables;
  store: Store;
  dataRefId: DataRefId;
  middlewareStates: MiddlewareStates;
}

export class WrappedRequestor<
  TVariables extends object = object,
  TResponse = unknown,
> {
  dataRefId: DataRefId;
  headers?: RequestHeaders;
  middlewareStates: MiddlewareStates;
  payload?: unknown;
  requestor: NetworkRequestor<TResponse>;
  spec: OverreactSpec<TVariables>;
  store: Store;
  uri: string;
  variables: TVariables;
  verb: RequestVerb;

  constructor(options: WrappedRequestorOptions<TVariables, TResponse>) {
    Object.assign(this, options);
    this.executeRequest = this.executeRequest.bind(this);
  }

  executeRequest() {
    return this.requestor(this.uri, this.verb, this.headers, this.payload);
  }
}
